import { enumPubDest } from "../constants";
import { Globals } from "../CoreApp/Globals";

export function handledocaction(docAction) {
  // All pending transactions need to complete before we can do a doc action
  var qSize = Globals._rfcMgr.QueueSize();
  if (qSize != 0) {
    // console.log("Waiting for RFC queue to empty (", qSize, ")");
    setTimeout(function () {
      handledocaction(docAction);
    }, 250);
    return;
  }
  var command = docAction.split("_")[0];
  switch (command) {
    case "refresh":
      //TODO: grand unified theory at some point here?
      if (Globals._wsMgr.GetDoc().IsServerChart()) Globals._wsMgr.RefreshBaseFromSource();
      else Globals._wsMgr.RefreshDocFromBase();
      break;
    case "savedoc":
      if (!Globals._wsMgr.GetDoc().IsServerChart()) Globals._wsMgr.DoSaveDocument(null);
      else console.warn("Invalid command");
      break;
    case "publish":
      var pubArg = docAction.split("_")[1];
      // Fallback for URL-encoded `^` (headless browsers normalize ^ to %5E,
      // and after a single decodeURIComponent it stays as the literal "%5E")
      var pubMode = pubArg.includes("^") ? pubArg.split("^") : pubArg.split("%5E");
      Globals._svrChartMgr.fOverridePubDest = enumPubDest.nodownload;
      Globals._wsMgr.PerformPublishCommand(pubMode[0], pubMode[1]);
      break;
    case "signoff":
      this.DoChangeDoc("signoff");
  }
}
